import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";

const firstButtonsDesign = {
  border: "1px solid #005FEC !important",
  color: "#0B1029 !important",
  backgroundColor: "#F5FAFF !important",
  borderRadius: "30px !important",

  "&:hover": {
    border: "1px solid #F5FAFF !important",
    color: "#005FEC !important",
  },
};

function CTNButton(props) {
  const { buttons, sendMessageToPreview, id, disabled } = props;
  const [disbaleBtn, setDisableBtn] = useState(disabled);

  const onClickHandler = (btn) => {
    if (btn && btn.buttonLink && isValidUrl(btn.buttonLink)) {
      window.open(btn.buttonLink, "_blank");
    } else {
      sendMessageToPreview(btn.text, btn.componentId);
      setDisableBtn(true);
    }
  };

  const Icon = styled("img")({
    width: 24,
    height: 24,
  });

  function isValidUrl(string) {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  }

  return (
    <div className="ctnButtonContainer" key={`${id}-ctnbuttoncontainer`}>
      {buttons.map((btn) => (
        <Button
          className="buttonPlain"
          disabled={disbaleBtn}
          onClick={(_) => onClickHandler(btn)}
          sx={{
            ...firstButtonsDesign,
            backgroundImage: `url(${
              isValidUrl(btn.backgroundMedia) ? btn.backgroundMedia : ""
            })`,
          }}
          style={{ textTransform: "none", fontSize: "12px" }}
          key={`${id}-ctnbuttonfirst-${btn.text}`}
          startIcon={
            isValidUrl(btn.iconMedia) ? <Icon src={btn.iconMedia} /> : ""
          }
        >
          {btn.text}
        </Button>
      ))}
    </div>
  );
}

export default CTNButton;
